import { ExternalConnection } from '@griply/types';
import { useReconnectExternalConnection } from 'features/external-connections';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { ExternalConnectionIcon } from 'shared/components/ui/external-connection-icon';

import * as Styled from './calendar-reconnect-notice.style';

export type CalendarReconnectRowProps = {
  connection: ExternalConnection;
};

export const CalendarReconnectRow: React.FC<CalendarReconnectRowProps> = ({
  connection,
}) => {
  const { t } = useTranslation();
  const { onReconnect, isPending } = useReconnectExternalConnection(connection);

  return (
    <Styled.Row>
      <Styled.IconContainer>
        <ExternalConnectionIcon provider={connection.provider} />
      </Styled.IconContainer>
      <Styled.Email>{connection.providerInfo.email}</Styled.Email>

      <Button
        variant={Variants.Contained}
        color={Colors.White}
        size={Sizes.Small}
        onClick={onReconnect}
        disabled={isPending}
      >
        {t('calendar.accounts.reconnect')}
      </Button>
    </Styled.Row>
  );
};
